export const SET_LAWS_ALL_PUB_FETCHING = 'SET_LAWS_ALL_PUB_FETCHING';
export const SET_LAWS_ALL_PUB = 'SET_LAWS_ALL_PUB';
export const SET_LAWS_ALL_PUB_ERROR = 'SET_LAWS_ALL_PUB_ERROR';
export const CLEAN_LAWS_ALL_PUB = 'CLEAN_LAWS_ALL_PUB';
export const ABORT_LAWS_ALL_PUB_REQUEST = 'ABORT_LAWS_ALL_PUB_REQUEST';
export const RESET_LAWS_ALL_PUB_FETCHING = 'RESET_LAWS_ALL_PUB_FETCHING';



// WEBPACK FOOTER //
// ./src/redux_related/lawsAllPublications/actions.js